export default __webpack_public_path__ + "static/media/polygons-no-3.0f1f4d4e.mid";